import { useLocation, useNavigate } from "react-router-dom";

/** п.26 ТЗ: нижнє меню, максимум 4-5 пунктів. */
const ITEMS = [
  { path: "/", icon: "🏠", label: "Головна" },
  { path: "/cars", icon: "🚗", label: "Автомобілі" },
  { path: "/credit", icon: "💳", label: "Розрахунок" },
  { path: "/favorites", icon: "♡", label: "Обране" },
  { path: "/consultants", icon: "👤", label: "Контакт" },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="bottom-nav">
      {ITEMS.map((item) => (
        <button
          key={item.path}
          className={`bottom-nav-item ${pathname === item.path ? "active" : ""}`}
          onClick={() => navigate(item.path)}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
